import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const IciciBankLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. Can ICICI Bank grant me a full moratorium?",
            content: "ICICI Bank may offer a complete moratorium on your overseas education loan if your application profile is very strong."
        },
        {
            title: "2. Are there any charges for prepaying the ICICI Bank education loan?",
            content: "ICICI Bank does not impose any prepayment penalty on your overseas education loan. So, you can repay the loan amount without any additional charges or fees."
        },
        {
            title: "3. I have been working in my current job for almost three years. Can I apply for ICICI Bank's experience-based product?",
            content: "It is mandatory to complete a minimum of 3 years in your professional career before being eligible for the experience-based product offered by ICICI Bank."
        },
        {
            title: "4. Is there any possibility of obtaining tax benefits if I take a loan from ICICI Bank?",
            content: "By opting for a loan from ICICI Bank, you can avail tax benefits under section 80(c). This implies that you can deduct your investments, allowing you to enjoy certain advantages when it comes to taxes."
        }, {
            title: "5. How much does ICICI Bank charge for processing fees on education loans?",
            content: "ICICI Bank charges processing fees that can vary from 0.5% to 1% plus GST. However, in some exceptional cases where the applicant has an excellent profile, the processing fees can be as low as 0.3%."
        },
        {
            title: "6. Who receives the loan, the borrower or the college/university?",
            content: "The university receives the tuition fees and on-campus housing fees, while other living expenditures are credited to the borrower’s account. "
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"ICICI Bank Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"ICICI Bank Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">ICICI Bank Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">ICICI Bank, a well-known bank in India’s private sector, was established in 1994. Despite the increasing expenses of higher education, ICICI Bank acknowledges the challenges that come with pursuing advanced studies. However, they believe that financial constraints should not hinder individuals from reaching their aspirations.
                                <br /><br />
                                To assiststudents in their pursuit of higher education abroad, Credere has partnered with ICICI Bank. ICICI Bank recognizes your ambitions for a successful career and provides student loans to support your pursuit of higher education. Applying for an Education Loan through ICICI Bank is a hassle-free and straightforward process.
                                <br /><br />
                                ICICI Bank has categorized the top educational institutions into various groups, namely A1, A2, A3, and A4, based on the specific university and course chosen. With flexible duration and repayment choices, reasonable interest rates, tax savings on interest paid under section 80(E), and a loan amount of up to Rs. 50 lakhs without the need for collateral, ICICI Bank helps students fulfill their goals of studying prestigious universities overseas.</p>
                            <h5 className="about-head">Overview of ICICI's Abroad Education Loan Program</h5>

                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            A1- 10.95%<br />
                                            A2-11.70%<br />
                                            A3-12.25%<br />
                                            A4-12.50%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            A1-50 Lakhs INR<br />
                                            A2- 40 Lakhs INR<br />
                                            A3 - 15 Lakhs INR<br />
                                            A4- On an immediate EMI bais

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest rate type</td>
                                        <td className="">

                                            Floating Interest rate

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Minimum Income(Co-Applicant)
                                        </td>

                                        <td className="">
                                            50,000 INR(without obligations)</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            0.5%-1% of the loan amount + GST

                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Repayment</td>
                                        <td>Need to pay S.I. only during course + 6 months grace period</td></tr>
                                    <tr>
                                        <td>Other Charges</td>
                                        <td>Nil</td>
                                    </tr>
                                </tbody>
                            </table>


                            <p className="loan-elegibility-des"><b>Note:</b> If the applicant’s and co-applicants profile is strong, a high CIBIL, academics percentage, and more than a full moratorium can be provided in this case i.e. no repayment during the course and grace period. </p>


                            <h5 className="about-head">ICICI Bank Eligibility Criteria for Studying Abroad Loan</h5>
                            <p className="loan-elegibility-des">To obtain approval for an education loan from ICICI Bank for studying abroad, you need to meet certain eligibility criteria.</p>

                            <ol className="subhead-ul">
                                <li>Indian citizenship is a requirement</li>
                                <li>The applicant must be aged between 16 and 35 years.</li>
                                <li>ICICI Bank only accepts admissions from universities or colleges that are on their approved list.</li>
                                <li>The co-applicant can only be one of the following: Father, Mother, Brother, Sister, Spouse (Husband/Wife), or Maternal/Paternal Uncle.</li>
                            </ol>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">ICICI Bank Offers Education Loans for Studying Abroad Based on Work Experience</h5>
                            <p className="loan-elegibility-des">In addition to regular study loans, ICICI Bank provides a unique product tailored for those who have work experience and aspire to go abroad for further education. This experience-based product by ICICI Bank has a range of aspects that make it stand out.</p>

                            <ol className="subhead-ul">


                                <li>Suitable for individuals with at least 3 years or more of professional experience. </li>
                                <li>The scheme is limited to universities/colleges in the A1 or A2 category on ICICI Bank’s approved institute list.</li>
                                <li>For this loan type, a co-applicant is not required.</li>
                                <li>The minimum salary required is 35,000 INR, but it may vary depending on the loan amount needed.</li>
                                <li>Throughout the moratorium period, there is no obligation to pay any sum of money. Nevertheless, it is essential to provide security by converting it into a fixed deposit (FD). The key advantage of this approach is that you will receive regular interest on the FD and the locked amount will be returned to you after the repayment period.</li>
                            </ol>
                            <p className="loan-elegibility-des">Note: The ICICI Bank requires the applicant to make a Fixed Deposit (FD) as security, which should be equal to the simple interest that needs to be paid during the moratorium period.</p>
                            <h5 className="about-head">List of Documents Needed for ICICI Bank Overseas Education Loan</h5>
                            <p className="loan-elegibility-des">To begin your loan application with ICICI Bank for overseas education, you will need certain mandatory documents.</p>
                            <ol className="subhead-ul">

                                <li>Admission letter with the cost of education if available</li>
                                <li>Aadhaar Card and PAN card of the student and Parent/Guardian</li>
                                <li>Copy of exam mark sheets of 10th/12th or latest education certificate</li>
                                <li>Passport</li>
                                <li>The electricity bill for residence proof</li>
                                <li>Relationship proof for your co-applicant</li>
                                <li>Most recent salary slips and Form 16 of the co-applicant (if salaried)</li>
                                <li>Proof of margin money (wherever applicable)</li>
                                <li>Updated ITR of 2 years or IT assessment order of the last 2 years of the co-applicant (if self-employed)</li>
                            </ol>
                            <h5 className="about-head">Advantages of Getting an ICICI Education Loan via Credere</h5>


                            <p className="loan-elegibility-des">You can obtain a few more advantages by pursuing a study abroad loan from ICICI Bank through Credere. Among these advantages are:</p>





                            <p className="loan-elegibility-des"><b>Best Loan Assurance</b></p>

                            <p className="loan-elegibility-des">Credere guarantees that you will get the most competitive education loan. We are committed to offering you the best deal available. If by any chance you come across a better offer, we will compensate for any variation in interest rates for the entire duration of your education loan.</p>



                            <p className="loan-elegibility-des"><b>Customized Document Checklist</b></p>

                            <p className="loan-elegibility-des"> ICICI requires several documents, but with Credere, you will receive a personalized document checklist tailored to your profile. This checklist will include all the necessary documents you need to provide. If there are any alternative document options available, they will also be mentioned in the checklist. </p>

                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>

                            <p className="loan-elegibility-des"> The loan process can be finished in 5–7 days with Credere’s assistance, however, according to ICICI Bank’s regular operational rules, going directly to them might take up to 10 days.</p>

                            <p className="loan-elegibility-des"><b>Completely Free Assistance</b></p>


                            <p className="loan-elegibility-des">  Credere connects you with an education loan expert who will assist you throughout the process at no extra charge when you check your eligibility and proceed with your loan.</p>

                            <p className="loan-elegibility-des"><b>Full Moratorium Offered</b></p>


                            <p className="loan-elegibility-des">  Credere can assist in obtaining a complete moratorium if the applicant and co-applicant have a strong overall profile, including a high CIBIL score, academic percentage, and more.  </p>
                            <h5 className="about-head">How to Apply for ICICI Education Loan for Studying Abroad via Credere?</h5>
                            <p className="loan-elegibility-des">To obtain a loan for studying abroad from ICICI, you have the option to apply conveniently on their website. However, for a more convenient application process, you can consider applying for your education loan through Credere.
                                <br /><br />
                                Credere helps Indian students finance their education abroad through an online platform. Begin your journey with us by checking your loan eligibility, and we’ll take care of the rest. </p>



                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default IciciBankLendingPartner;